if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();

        requestAnimationFrame(() => {
          const container = this.querySelector('[role="document"]');
          if (!container) return;

          const activeMedia = this.querySelector(
            `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
          );
          if (!activeMedia) return;

          const containerRect = container.getBoundingClientRect();
          const mediaRect = activeMedia.getBoundingClientRect();
          const mediaTopInContainer = (mediaRect.top - containerRect.top) + container.scrollTop;

          const offset = Math.round(container.clientHeight * 0.6);

          container.scrollTo({
            top: mediaTopInContainer + offset,
            left: container.scrollLeft,
            behavior: 'smooth',
          });
        });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
